<template>
	<div :class="{'ly-is-full':isFull}">
		<div class="tableSelect" ref="tableSelect">
			<!-- <el-form :inline="true" :model="formInline" ref="queryFrom" label-position="left">
				<el-form-item label="分类名称：">
					<el-input v-model="formInline.name" placeholder="请输入分类名称"></el-input>
				</el-form-item>
				<el-form-item label="">
					<el-button @click="handleSearchClick('search')" type="primary" icon="Search">查询</el-button>
				</el-form-item>
				<el-form-item label="">
					<el-button @click="handleSearchClick('reset')" icon="Refresh">重置</el-button>
				</el-form-item>
			</el-form> -->
		</div>
		<div class="table">
			<div class="tableToolBar">
				<div>
					<el-button type="primary" icon="Plus" @click="dialogFlag=true;title='新增分类'">新增</el-button>
					<el-button type="danger" icon="Delete" @click="removeHandler"
						:disabled="selectList.length == 0">删除</el-button>
				</div>
			</div>
			<el-table v-bind="tableOptions" :data="tableData" :height="tableHeight" ref="tableref" row-key="id"
				style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="50" align="center" />
				<el-table-column prop="name" label="分类名称" align="center" />
				<el-table-column prop="create_datetime" label="创建时间" align="center" />
				<el-table-column prop="update_datetime" label="更新时间" align="center" />
				<el-table-column label="操作" align="center" width="300">
					<template #header>
						<div style="display: flex;justify-content: space-between;align-items: center;">
							<div>操作</div>
							<div @click="setFull">
								<el-tooltip content="全屏" placement="bottom">
									<el-icon><full-screen /></el-icon>
								</el-tooltip>
							</div>
						</div>
					</template>
					<template #default="scope">
						<div style="display: flex;">
							<el-button icon="Edit" type="primary" plain text size="small"
								@click="editHandler(scope.row)">编辑</el-button>
							<el-button v-if="scope.row.id>3" icon="Delete" type="danger" plain text size="small"
								@click="removeRow(scope.row)">删除</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<Pagination :child-msg="formInline" @callFather="callFather" />
		<ly-dialog v-model="dialogFlag" :title="title" width="40%" :before-close="handleDialogClose">
			<div>
				<el-form ref="columnForm" :model="columnData" :rules="rules" label-width="100px">
					<el-form-item label="分类名称" prop="name">
						<el-input v-model="columnData.name" placeholder="请输入分类名称" clearable></el-input>
					</el-form-item>
				</el-form>
			</div>
			<template v-slot:footer>
				<div style="display: flex;justify-content: flex-end;">
					<el-button @click="handleDialogClose">取消</el-button>
					<el-button type="primary" @click="submitData">确定</el-button>
				</div>
			</template>
		</ly-dialog>
	</div>
</template>

<script setup>
	import Pagination from "@/components/Pagination"
	import {
		categoryGet,
		categoryPost,
		categoryPut,
		categoryDelete,
		categoryDeleteMultiple
	} from "@/api/court"
	import LyDialog from "@/components/dialog/dialog"
	import {
		ElMessage,
		ElMessageBox
	} from 'element-plus'
	import {
		getTableHeight
	} from "@/utils/util"
	import {
		ref,
		reactive,
		watch,
		onMounted,
		onUnmounted,
		nextTick
	} from "vue"

	const tableSelect = ref(null)
	const columnForm = ref(null)
	const isFull = ref(false)

	const tableData = ref([])
	const tableHeight = ref(500)

	const dialogFlag = ref(false)
	const title = ref("")
	const selectList = ref([])

	const formInline = reactive({
		page: 1,
		limit: 10,
		total: 0,
		name: ""
	})

	let columnData = reactive({
		name: ""
	})

	const rules = reactive({
		name: [{
				required: true,
				message: '请输入分类名称',
				trigger: 'blur'
			},
			{
				max: 100,
				message: '分类名称最多只能输入100个字符',
				trigger: 'blur'
			}
		]
	})

	const tableOptions = ref({
		stripe: false, // 斑马纹
		highlightCurrentRow: false, // 是否要高亮当前行
		border: true, // 是否有纵向边框
		fit: true, // 列的宽度是否自撑开
		size: 'default', // Table 的尺寸
		lazy: false, // 是否需要懒加载
		showHeader: true, //是否显示表头
		defaultExpandAll: false, //是否默认展开所有行
	})

	//初始化页面
	function initPage() {
		categoryGet(formInline).then(res => {
			if (res.code == 2000) {
				formInline.total = res.data.total
				tableData.value = res.data.data
			}
		})
	}

	//搜索栏中的查询与重置按钮事件
	function handleSearchClick(type) {
		if ("reset" == type) {
			formInline.name = ""
		}
		initPage()
	}

	//分页sizechange、pagechange事件
	function callFather(params) {
		formInline.limit = params.limit
		formInline.page = params.page
		initPage()
	}

	//多选框选中的数据 将选中的数据放入selectList数组中
	function handleSelectionChange(selection) {
		selectList.value = selection
	}

	//dialog取消事件 清空输入框中的值
	function handleDialogClose() {
		dialogFlag.value = false
		columnForm.value.resetFields()
		Object.assign(columnData, {
			name: ""
		})
	}

	//dialog点击确定事件，将表单内容发往后端
	function submitData() {
		columnForm.value.validate(flag => {
			if (flag) { //验证表单成功
				if (columnData.id) categoryPut(columnData).then(res => { //更新
					if (res.code == 2000) {
						ElMessage.success("更新分类成功~")
						initPage()
						handleDialogClose()
					} else ElMessage.warning(res.msg)
				})
				else categoryPost(columnData).then(res => { //新增
					if (res.code == 2000) {
						ElMessage.success("新增分类成功~")
						initPage()
						handleDialogClose()
					} else ElMessage.warning(res.msg)
				})
			}
		})
	}

	//表格中的删除事件 所有的删除事件需要进行一次确认 直接将这一行数据放到selectList数组中
	function removeRow(data) {
		ElMessageBox.confirm('是否确认删除当前行的数据', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(f => {
			remove([data])
		})
	}

	//根据选中的数据进行删除 删除完毕后需要清空selectList数组
	function removeHandler() {
		if (!selectList.value.length) return
		ElMessageBox.confirm('是否确认删除选择的数据', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(f => {
			remove(selectList.value)
		})
	}

	//通用发起删除请求
	function remove(arr) {
		if (arr.some(node => node.id < 3)) return ElMessage.warning("含有初始数据无法删除")
		let flags = []
		arr.map(item => {
			categoryDelete(item.id).then(res => {
				if (res.code == 2000) {
					flags.push(true)
					if (flags.length == arr.length) {
						ElMessage.success("分类删除成功")
						initPage()
					}
				} else ElMessage.warning(res.msg)
			})
		})
	}

	//表格中编辑事件 data为那一行的数据
	function editHandler(data) {
		dialogFlag.value = true
		title.value = "修改分类信息"
		Object.assign(columnData, JSON.parse(JSON.stringify(data)))
	}

	function setFull() {
		isFull.value = !isFull.value
		window.dispatchEvent(new Event('resize'))
	}

	function getTheTableHeight() {
		let tabSelectHeight = tableSelect ? tableSelect.value.offsetHeight : 0
		tabSelectHeight = isFull.value ? tabSelectHeight - 110 : tabSelectHeight
		tableHeight.value = getTableHeight(tabSelectHeight, false) - 225
	}

	function listenResize() {
		nextTick(() => {
			getTheTableHeight()
		})
	}

	onMounted(() => {
		initPage()
		getTheTableHeight()
		window.addEventListener('resize', listenResize);
	})

	onUnmounted(() => {
		window.removeEventListener("resize", listenResize);
	})
</script>

<style scoped lang="scss">
	.tableToolBar {
		display: flex;
		justify-content: flex-end;
		font-size: 14px;
		background: var(--el-bg-color);
		padding: 8px;
		border-top: 1px solid var(--el-border-color-lighter);
		border-left: 1px solid var(--el-border-color-lighter);
		border-right: 1px solid var(--el-border-color-lighter);
	}
</style>